/**
 * VERAX: Política de contraseñas (copia de src/auth/password-policy.ts: mantener iguales)
 *
 * Una sola definición, usada por el servidor (alta, cambio, usuario inicial) y
 * mostrada tal cual en la interfaz, para que la regla que se ve sea la que se aplica.
 */

export const PASSWORD_RULES = [
  { id: 'len', label: 'Al menos 12 caracteres', test: (p: string) => p.length >= 12 && p.length <= 128 },
  { id: 'upper', label: 'Una letra mayúscula', test: (p: string) => /[A-ZÁÉÍÓÚÑ]/.test(p) },
  { id: 'lower', label: 'Una letra minúscula', test: (p: string) => /[a-záéíóúñ]/.test(p) },
  { id: 'digit', label: 'Un número', test: (p: string) => /\d/.test(p) },
  { id: 'symbol', label: 'Un símbolo, por ejemplo ! @ # $ % - _', test: (p: string) => /[^A-Za-z0-9ÁÉÍÓÚÑáéíóúñ\s]/.test(p) },
  { id: 'spaces', label: 'Sin espacios al inicio ni al final', test: (p: string) => p === p.trim() }
] as const;

export const PASSWORD_HINT = 'Mínimo 12 caracteres, con mayúscula, minúscula, número y símbolo.';

/** Devuelve null si cumple; si no, un mensaje con lo que falta. */
export const checkPassword = (plain: string, email?: string): string | null => {
  if (typeof plain !== 'string') return 'Contraseña inválida';
  if (plain.length > 128) return 'La contraseña no puede superar 128 caracteres';
  const missing = PASSWORD_RULES.filter((r) => !r.test(plain)).map((r) => r.label.toLowerCase());
  if (missing.length) return `La contraseña debe tener: ${missing.join(', ')}.`;
  const local = (email ?? '').split('@')[0]?.toLowerCase();
  if (local && local.length >= 4 && plain.toLowerCase().includes(local)) return 'La contraseña no puede contener el usuario del correo.';
  if (/^(.)\1+$/.test(plain)) return 'La contraseña no puede ser un solo carácter repetido.';
  return null;
};
